"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _color = _interopRequireDefault(require("color"));

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

var _utils = require("../utils");

var _LottieAnimationAPI2 = _interopRequireDefault(require("./LottieAnimationAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * prepareText() returns a lines array
 * break the text value into line
 */
function prepareText(text, textTransform, config) {
  text = (0, _utils.NormalizeText)(text);
  var lines = [];
  text.split('<br>').forEach(function (line) {
    line = (0, _utils.ConvertCase)(line, textTransform); // remove the logic for line limit

    var splitEqualValue = (0, _utils.SplitEqual)(line, config.maxCharInline);
    splitEqualValue.forEach(function (lineValue) {
      lines.push(lineValue);
    });
  }); // remove the logic for line limit
  // lines = flattenDeep(lines)

  if (lines.length < config.minLines) {
    var needToadd = config.minLines - lines.length;
    lines = lines.concat(Array(needToadd).fill(''));
  } else if (lines.length > config.maxLines) {
    // merge the lines that pass the max line limit to one and set them as the last line
    var last = lines.splice(config.maxLines - 1, lines.length);
    lines.push(last.join(' '));
  }

  return lines;
}
/**
 * applayFonts() returns a animation data
 * set animation fonts if defined for current animation
 */


function applayFonts(data, fonts) {
  var retData = Object.assign({}, data);

  if (fonts) {
    for (var i = 0; i < fonts.length; i++) {
      if (data.fonts.list[i] !== undefined) {
        data.fonts.list[i].fFamily = fonts[i].font; // set font weight if not set use default 400 (normal)

        data.fonts.list[i].fWeight = fonts[i].weight ? fonts[i].weight : 400;
      }
    }
  }

  return retData;
}

var parser = new _uaParserJs.default();

function getBrowserName() {
  return parser.getBrowser().name;
}

function getCssStyle(style, videoScale) {
  var width = style.width,
      height = style.height,
      x = style.x,
      y = style.y;
  return {
    position: 'absolute',
    width: width ? width * videoScale : '100%',
    height: height ? height * videoScale : '100%',
    left: x ? "".concat(x * videoScale, "px") : '0px',
    top: y ? "".concat(y * videoScale, "px") : '0px'
  };
}

var LottieAnimationBase = /*#__PURE__*/function (_LottieAnimationAPI) {
  _inherits(LottieAnimationBase, _LottieAnimationAPI);

  var _super = _createSuper(LottieAnimationBase);

  function LottieAnimationBase(animObj, data, config) {
    var _this;

    _classCallCheck(this, LottieAnimationBase);

    _this = _super.call(this);
    _this.animObj = animObj;
    _this.userFonts = animObj.fonts;
    _this.videoScale = animObj.videoScale || 1;
    _this.browserName = getBrowserName();
    _this.lines = prepareText(data.value, data.textTransform, config);
    _this.inDuration = animObj.inDuration || config.inDuration;
    _this.originInDuration = config.inDuration;
    _this.intermissionDuration = config.intermissionDuration;
    _this.outDuration = animObj.outDuration || config.outDuration;
    _this.originOutDuration = config.outDuration;
    _this.totalDuration = config.totalDuration;
    _this.width = config.width;
    _this.height = config.lineHeight.base + (_this.lines.length - 1) * config.lineHeight.extra;
    _this.fonts = data.fonts ? data.fonts : null;
    _this.textShadow = config.textShadow;
    _this.isStatic = !!config.isStatic;

    if (data.style) {
      _this.style = data.style;
    }

    _this.colorsObj = [];
    _this.colors = [];
    var colors = [];

    if (data.colors === null || data.colors === undefined || data.colors.length === 0) {
      colors = config.default.colors;
    } else {
      colors.push(data.colors[0] === null || data.colors[0] === undefined ? config.default.colors[0] : data.colors[0]);

      if (config.default.colors.length > 1) {
        colors.push(data.colors[1] === null || data.colors[1] === undefined ? config.default.colors[1] : data.colors[1]);
      }
    }

    colors.forEach(function (color) {
      _this.colorsObj.push((0, _color.default)(color));

      _this.colors.push((0, _utils.colorConvertLottie)((0, _color.default)(color).rgb().array()).join(','));
    });
    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(LottieAnimationBase, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      var _this2 = this;

      if (!data || !container) {
        window.console.info('missing data or conatiner');
        return;
      }

      var textShadowStyle = '1px 1px 10px rgba(10, 10, 10, 0.2)';
      this.container = container;
      var style = {}; // when have style render animation parent whit style to position and size

      if (this.style) {
        if (this.isStatic) {
          style = {
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          };
        } else {
          style = getCssStyle(this.style, this.videoScale);
        }
      }

      this.innerContainer = document.createElement('span');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer); // create lottie animation

      if (!this.isStatic) {
        data.h = this.height;
        data.w = this.width;
      }

      data = applayFonts(data, this.fonts);
      this.animation = _lottieWeb.default.loadAnimation({
        container: this.innerContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data
      });
      this.animation.addEventListener('DOMLoaded', function () {
        if (_this2.animation && _this2.textShadow) {
          var textIndex = 0; // for (const elem of this.animation.renderer.elements) {

          _this2.animation.renderer.elements.forEach(function (elem) {
            if (elem.constructor.name === 'SVGTextElement') {
              ++textIndex;

              if (_this2.textShadow.includes('*') || _this2.textShadow.includes(textIndex)) {
                var childNode = elem.layerElement.childNodes ? elem.layerElement.childNodes[0] : null;

                if (childNode) {
                  // workround for Edge use svg filter taht injected to dom by initUtils.js Init method
                  if (getBrowserName() === 'Edge') {
                    childNode.setAttribute('filter', 'url(#EDGElDCZudYwNm)');
                  } else {
                    childNode.style.textShadow = textShadowStyle;
                  }
                }
              }
            }
          }); // }

        }

        _this2.ready = true;

        _this2.animation.trigger('ready');

        if (typeof _this2.afterReady === 'function') {
          _this2.afterReady();
        }
      });
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      window.console.log('ANIMATION - prepareAssets');
      return (0, _utils.LoadFonts)(this.userFonts, 7000);
    }
  }, {
    key: "goToAndStop",
    value: function goToAndStop(time) {
      _get(_getPrototypeOf(LottieAnimationBase.prototype), "goToAndStop", this).call(this, this.getScaledTime(time));
    }
  }, {
    key: "goToIdle",
    value: function goToIdle() {
      var _this3 = this;

      _get(_getPrototypeOf(LottieAnimationBase.prototype), "_validate", this).call(this);

      this.animation.setSpeed(this.originInDuration / this.inDuration);
      this.playSegments([0, this.originInDuration]);
      setTimeout(function () {
        _this3.animation.setSpeed(1);
      }, 100);
    }
  }, {
    key: "updateSizeAndPosition",
    value: function updateSizeAndPosition(rect) {
      this.style = _objectSpread(_objectSpread({}, this.style), rect);
      var style = getCssStyle(this.style, this.videoScale);

      _gsap.TweenMax.set(this.innerContainer, style);
    }
  }, {
    key: "updateVideoScale",
    value: function updateVideoScale(scale) {
      this.videoScale = scale || 1;

      if (this.isStatic) {
        return;
      }

      this.updateSizeAndPosition(this.style);
    }
  }]);

  return LottieAnimationBase;
}(_LottieAnimationAPI2.default);

exports.default = LottieAnimationBase;